import {Theme} from '@material-ui/core/styles';
import {Overrides} from '@material-ui/core/styles/overrides';
import {Calendar} from '@material-ui/core/styles/createPalette';

import {createMuiPickersCalendarHeaderOverrides} from './MuiPickersCalendarHeader';
import {createMuiPickersCalendarOverrides} from './MuiPickersCalendar';
import {createMuiPickersDayOverrides} from './MuiPickersDay';
import {createMuiPickersMonthSelectionOverrides} from './MuiPickersMonthSelection';
import {createMuiPickersMonthOverrides} from './MuiPickersMonth';
import {createMuiPickersYearOverrides} from './MuiPickersYear';

export const createPickersOverrides = (theme: Theme): Overrides => ({
    // @ts-ignore
    MuiPickersCalendar: createMuiPickersCalendarOverrides(theme),
    MuiPickersCalendarHeader: createMuiPickersCalendarHeaderOverrides(theme),
    MuiPickersDay: createMuiPickersDayOverrides(theme),
    MuiPickersMonthSelection: createMuiPickersMonthSelectionOverrides(theme),
    MuiPickersMonth: createMuiPickersMonthOverrides(theme),
    MuiPickersYear: createMuiPickersYearOverrides(theme)
});

// to-do: configure the color differentiations?
export const calendar: Calendar = {
    selected: {
        light: '#1063B4',
        main: '#1063B4',
        dark: '#1063B4',
        contrastText: '#1063B4'
    },
    preselected: {
        light: '#4A4A4A',
        main: '#4A4A4A',
        dark: '#4A4A4A',
        contrastText: '#4A4A4A'
    },
    preselectedFirst: {
        light: '#5A5A5A',
        main: '#5A5A5A',
        dark: '#5A5A5A',
        contrastText: '#5A5A5A'
    }
};
